interface CodeToMessage {
  [key: string]: string
}

export const UNKNOWN_ERROR = 'An unknown error occurred';

export const FirebaseErrorToClientMessages: CodeToMessage = {
  'auth/wrong-password': 'Email or password was incorrect',
  'auth/user-not-found': 'Email or password was incorrect',
};